export default __webpack_public_path__ + "static/AirConditioning-07dd5b723bbc8036baeb25dc87c19056.jpg";